module.exports = __webpack_public_path__ + "img/DE.4130265d.jpg";